import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { logger } from 'features/logger/logger';
import { defaultNS, ns } from './constants';
import { dynamicI18n } from './DynamicTranslation/dynamicI18n';
import { appLocales, defaultLocale } from './locales';
import enUSCommon from './locales/en-US/common.json';
import frFRCommon from './locales/fr-FR/common.json';
import nlNLCommon from './locales/nl-NL/common.json';
import type { AppLocales } from '@hub/common';
import type { ResourceLanguage } from 'i18next';

const resources = {
  'en-US': { common: enUSCommon },
  'nl-NL': { common: nlNLCommon },
  'fr-FR': { common: frFRCommon },
} satisfies Record<AppLocales, { common: ResourceLanguage }>;

const i18n = createInstance();
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLocale,
    fallbackLng: defaultLocale,
    supportedLngs: appLocales,
    debug: import.meta.env.MODE === 'development',
    ns,
    defaultNS,
    cleanCode: true,
    load: 'currentOnly',
    interpolation: { escapeValue: false },
  })
  .catch((err: unknown) => {
    logger.error(
      'i18next init failed',
      undefined,
      err instanceof Error ? err : new Error(String(err))
    );
  });

i18n.on('languageChanged', language => {
  logger.info(`Main translation language changed to: ${language}`);
  void dynamicI18n.changeLanguage(language);
});

// eslint-disable-next-line import/no-default-export -- i18n is a global object
export default i18n;
